import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SafeHtml, DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EnergyReportsService } from './energy-reports.service';
import { PlatformLocation } from '@angular/common';
import { SessionStateService } from '../../../core/services/session-state.service';
import { ApiService } from '../../../core/services/api.service';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { environment as envPrd} from '../../../../environments/environment.prd';
import { environment as envQa} from '../../../../environments/environment.qa';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-energy-reports',
  templateUrl: './energy-reports.component.html',
  styleUrls: ['./energy-reports.component.scss']
})
export class EnergyReportsComponent implements OnInit {
  data: SafeHtml;
  
  @ViewChild('iframe') iframe: ElementRef;
    
  _reportId: string = null;
  _houseId: string = null;
  _userToken: string = null;
  loading = false;
  isReport = true;
  
  externalContent: string;
  
  constructor(
    public sanitizer: DomSanitizer,
    private sessionStateService: SessionStateService,
    private energyReportsService: EnergyReportsService,
    private api: ApiService
    ) {
    }
    
  ngOnInit() {
    this.loadReports();
  }

  loadReports(): void {
    this.loading = true;
    this.energyReportsService.getReportsToken().subscribe(() => {
      this.energyReportsService.getReports().subscribe((_reports: any) => {
        if ( _reports.reports.length > 0 ) {
          this._reportId = _reports.getMostRecentReport().getId().toString();
          this._houseId = this.sessionStateService.getHouse().houseId;
          this._userToken = this.sessionStateService.getReportsToken();
          this.getExternalContent();
        } else {
          this.isReport = false;
        }
        this.loading = false;
      });
    });
  }

  getExternalContent(): void {
    let url = '';
    if (environment.qa) {
      url = `${envQa.reports.url}/reports/${this._reportId}`;
    } else {
      url = `${envPrd.reports.url}/reports/${this._reportId}`;
    }

    const headers = new HttpHeaders()
      .set('X-User-Username', this.sessionStateService.getReportsUsername())
      .set('X-User-Token', this._userToken)
      .set('cache-control', 'no-cache');

    this.api.getRaw(url, headers).subscribe(response => {
      if (this.iframe == null) {
        // console.error('no iframe?');
        return;
      }

      if (response.status != 200) {
        // show error message?
        // console.error('non ok response from external provider', response.status);
        return;
      }

      const win: Window = this.iframe.nativeElement.contentWindow;
      const doc: Document = win.document;
      doc.open();
      doc.write(response.body);
      doc.close();
      this.loading = false;
      this.isReport = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-reports/energy-reports.component.ts